import { PUBLIC_URL } from '../../config/settings/environment'
import { BEHAVIOR_INDICATOR_FILE } from '../../config/settings/constant'

export const BEHAVIOR_INDICATOR_FILE_URL = `${PUBLIC_URL}/assets/images/${BEHAVIOR_INDICATOR_FILE}`

export const EMPTY_CHART = { categories: [], data: [] }
export const EMPTY_CHART_WITH_WEIGHTS = { categories: [], data: [], weights: [] }

export const BEHAVIOR_INDICATORS_ERROR =
  'No ha sido posible obtener información de la institución. Por favor, te pedimos que lo vuelvas a intentar dentro de unos minutos.'

export const FORMULA_LABEL_PREFIXES = [
  'órdenes de compra que se realizan fuera del Plan Anual de Compras (PAC)',
  'Cantidad de ',
  'Tiempo de ',
  'Tiempo  de ',
  'Compras ',
  'Cantidad ',
  'Montos de ',
  'Monto total de ',
  'Número de ',
  'Número total de ',
  'Solicitudes en ',
  'porcentaje de reclamos por irregularidades asociados a los procesos de licitación pública',
  'licitaciones públicas que fueron declaradas desiertas',
  'competencia en las licitaciones privadas',
  'solicitudes realizadas por modalidad Compra Ágil',
  'proveedores adjudicados que cuentan con Sello de Sustentabilidad',
  'proveedores adjudicados que cuentan solo con Sello de Sustentabilidad',
  'proveedores adjudicados que cuentan con Sello Mujer',
  'proveedores adjudicados que cuentan solo con Sello Mujer',
  'proporción de órdenes de compra realizadas mediante Trato Directo',
  'proporción del monto total adjudicado mediante Trato Directo',
  'porcentaje de órdenes de compra emitidas en Convenio Marco respecto del total de órdenes de compra de un organismo',
  'porcentaje del monto total adjudicado en Convenio Marco respecto del monto total de órdenes de compra de un organismo',
  'competencia en las licitaciones públicas',
  'procesos de contratación realizados mediante licitación privada',
  'porcentaje de compras ágiles adjudicadas en el primer llamado respecto del total de compras ágiles realizadas',
  'número de días que tardan los organismos públicos en evaluar las ofertas en un proceso de Compra Ágil',
  'el plazo esperado y el plazo real',
  'cantidad de RFI realizados en el período',
  'licitaciones y compras ágiles que incorporan criterios sustentables y/o de género',
  'porcentaje de supervisores que cuentan con acreditación en nivel intermedio o superior',
  'porcentaje de reclamos por pago no oportuno en relación con el total de órdenes de compra',
  'porcentaje de reclamos por irregularidades asociados a los procesos de licitación pública',
  'usuarios de la institución que mantienen vigente su certificación'
]

export const BASE_SERIE = {
  name: 'Valor',
  data: [],
  pointPlacement: 'on',
  color: '#1976d2',
  lineWidth: 2,
  fillOpacity: 0.2,
  marker: {
    enabled: true
  }
}

export const SECTION_LOADING_PARAMETERS = [
  {
    val: 1,
    height: 40
  },
  {
    val: 2,
    height: 40
  },
  {
    val: 3,
    height: 300
  },
  {
    val: 4,
    height: 100
  },
  {
    val: 5,
    height: 300
  },
  {
    val: 6,
    height: 100
  },
  {
    val: 7,
    height: 300
  }
]

export const DIMENSION_COLORS = [
  '#544FC5', // Participación de proveedores en Mercado Público
  '#20CBA9', // Procedimientos de compra
  '#F16145', // Eficiencia en los procesos
  '#4DBCDB', // Buenas prácticas
  '#F1C345' // Normativa
]

/**
 * Custom options for the dimensions spider chart
 */
export const SPIDER_CHART_OPTIONS = (title, inDimensionsChart = false) => ({
  xAxis: {
    opacity: 1,
    labels: {
      useHTML: true,
      distance: 40,
      formatter: function () {
        const category = this.value
        const point = this.chart.series[0]?.data[this.pos]
        const value = point?.y || 0
        const weight = point?.weight || 0

        return `
          <div style="text-align: center; width: ${inDimensionsChart ? '200px' : '150px'}; text-wrap: auto; padding: 20px 0px; margin-left: ${inDimensionsChart ? '-30px' : '-15px'}">
            <div style="font-weight: bold; font-size: 17px; color: #1a365d;">
              ${value?.toFixed(2).replace('.', ',')} 
              <span style="font-weight: normal; font-size: 13px; color: #9ca3af;">/ ${weight}%</span>
            </div>
            <div style="font-size: 12px; color: #4a5568; line-height: 1.3; margin-top: 4px;">
              ${category}
            </div>
          </div>
        `
      }
    }
  },
  title: {
    text: title,
    align: 'left',
    y: 10,
    style: {
      fontSize: '18px',
      fontWeight: 'bold',
      display: 'none'
    }
  }
})

/** Config for transformToOptions: sort + map per payload type */
export const OPTIONS_TRANSFORM_CONFIG = {
  years: {
    sort: (a, b) => a - b,
    map: year => ({ name: year, value: year })
  },
  months: {
    sort: (a, b) => b.value - a.value,
    map: month => ({ name: month.label, value: month.value })
  },
  dimensions: {
    sort: (a, b) => a.order - b.order,
    map: dim => ({ name: dim.name, value: dim.id })
  },
  dimensionsIndicators: {
    sort: (a, b) => a.order - b.order,
    map: ind => ({
      id: ind.code,
      name: ind.name,
      value: ind.id,
      description: ind.description,
      formula: ind.formulaUi,
      weight: ind.weighter,
      lastUpdate: ind.lastUpdate
    })
  }
}
